import React, { Fragment, useState, useEffect } from 'react';
import Loader from 'react-loader-spinner';
import { v4 as uuidv4 } from 'uuid';

//Components
import Item from '../components/Item';
import ServicesSearch from '../services/ServicesSearch';

function PymeAlternativesSection(props) {
  const limit = 4;
  const [pymes, setPymes] = useState([]);
  const [loader, setLoader] = useState(true);
  const [limitCards, setLimitCards] = useState(window.innerWidth<768 ? 2 : 4);

  useEffect(() => {
    const getData = (rutPyme) => {
      const categoriesForSuggestion = props.pyme.categoryArr;

      let params = {
          '_size' : limit,
          '_random' : uuidv4()
      };

      categoriesForSuggestion.map((category, index)=>{
        params['categories']=category;
        return index = 0;
      })

      ServicesSearch.getDataPyme(params)
        .then(response => {
          setPymes(response.data['hits']);
          setLoader(false);
        })
        .catch(e => {
          setLoader(false);
          console.log(e);
        });
    };

    props.pyme.rutPyme !== undefined && getData(props.pyme.rutPyme);
  }, [props.pyme.rutPyme, props.pyme.categoryArr]);

  return (
    <Fragment>
      <div className="row p-0">
        <div className="col p-0">
          <h4>
            <strong>Más opciones que te pueden interesar</strong>
          </h4>
          <div className="row px-0">
            {loader ? (
              <div className="spinner-d">
                <Loader
                  type="Oval"
                  color="#00BFFF"
                  height={50}
                  width={50}
                  className="spinner-1"
                />
              </div>
            ) : (
              pymes.map((pyme, index)=>(
                index<limitCards ?
                <Item
                  key={index}
                  width={'3'}
                  image={pyme._source.imagePymeURL}
                  title={pyme._source.namePyme}
                  specialFactor={pyme._source.specialFactor !== undefined ? pyme._source.specialFactor : ''}
                  obj={pyme}
                  />
                :
                null
              ))
            )}
          </div>
          {
            limitCards===2 ?
              <div className="col-md-12">
                <br/>
                <button
                  className = {"btn btn-outline-salmon btn-block "}
                  onClick={() => setLimitCards(4)}
                >
                  Ver más pymes
                </button>
              </div>
            :
              null
          }

        </div>
      </div>
    </Fragment>
  );
}

export default PymeAlternativesSection;
